import ChooseContact from "components/AddresseePicker/ChooseContact";
import LabelledDivRow from "components/LabelledDivRow";
import NumberInput from "components/NumberInput";
import OptionalTimePicker from "components/OptionalTimePicker";
import VenueModalPicker from "components/Picker/VenuePicker/VenueModalPicker";
import AgeRestrictionDropdown from "components/dropdowns/reactselect/AgeRestrictionDropdown";
import React from "react";
import { venueToCompany } from "utilities/companyUtils";
import { parseFromTime } from "utilities/momentutils";

interface Props {
  venue: server.dto.VenueSmall
  onVenueChange: (
    venue: server.dto.VenueSmall,
    capacity: number,
    ageRestriction: server.dto.AgeRestriction,
    doorsOpen: moment.Moment | null,
    doorsClose: moment.Moment | null
  ) => void
  onVenueRemoved: () => void

  contact: server.dto.ContactSmallV2
  onContactChange: (contact: server.dto.ContactSmallV2) => void

  capacity: number
  onCapacityChange: (capacity: number) => void

  ageRestriction: server.dto.AgeRestriction
  onAgeRestrictionChange: (ageRestriction: server.dto.AgeRestriction) => void

  doorsOpen: moment.Moment | null
  onDoorsOpenChange: (doorsOpen: moment.Moment | null) => void

  doorsClose: moment.Moment | null
  onDoorsCloseChange: (doorsClose: moment.Moment | null) => void
}

const VenuePanel = (props: Props) => {
  const onVenueSelected = async (selected: server.dto.VenueSmall) => {
    if (selected == null) {
      props.onVenueRemoved();
      return;
    }

    const venueRes = await window.CoreApi.Venue.GetVenue(selected.venueId);

    const ageRestriction = serverReference.ageRestrictions.find((val) => val.value === venueRes.data.details.ageRestriction);

    props.onVenueChange(selected, venueRes.data.details.capacity?.value, ageRestriction, venueRes.data.details.doors?.open ? parseFromTime(venueRes.data.details.doors.open) : null, venueRes.data.details.doors?.close ? parseFromTime(venueRes.data.details.doors.close) : null
    );
  };

  const hasVenue = props.venue != null;

  return (<>
    <LabelledDivRow label={site.currentEnvironment.functionGroups.venue.singular}>
      <div>
        <VenueModalPicker
          value={props.venue}
          onChange={v => onVenueSelected(v)}
          canCreateNew
          required={false}
          validatorKey="venue"
        />
      </div>
      {hasVenue && <div className="grow1">
        <ChooseContact
          company={venueToCompany(props.venue)}
          selectedContact={props.contact}
          onContactChanged={props.onContactChange}
        />
      </div>}
    </LabelledDivRow>
    {hasVenue && <>
      <LabelledDivRow label={RESX.Venue.Capacity}>
        <div className="flex gap-small">
          <div>
            <NumberInput
              maxLength={6}
              maxValue={serverReference.constants.venue.maxCapacity}
              value={props.capacity}
              canBeEmpty
              canBeNegative={false}
              decimalPoints={0}
              onChanged={v => { props.onCapacityChange(v.value); }}
              width={60}
            />
          </div>
          <div className="align-center" style={{ alignSelf: "center" }}>
            PAX
          </div>
        </div>
      </LabelledDivRow>

      <LabelledDivRow label={RESX.Venue.AgeRestrictions}>
        <AgeRestrictionDropdown
          value={props.ageRestriction}
          onChange={props.onAgeRestrictionChange}
        />
      </LabelledDivRow>

      <LabelledDivRow label={RESX.TimetableEvent.DoorsOpen}>
        <OptionalTimePicker
          value={props.doorsOpen}
          onChange={props.onDoorsOpenChange}
        />
      </LabelledDivRow>

      <LabelledDivRow label={RESX.TimetableEvent.DoorsClose}>
        <OptionalTimePicker
          value={props.doorsClose}
          onChange={props.onDoorsCloseChange}
        />
      </LabelledDivRow>
    </>}
  </>
  );
};

export default VenuePanel;